<template>
  <div class="w-100">
    <v-list
      nav
      density="compact"
      class="pa-0 w-100"
      v-for="(item, index) in items"
      :key="index"
    >
      <ui-list-item
        class="ui-card mb-1"
        :icon="IconForFilterList(item.type)"
        :title="item.name"
        arrow
        @click="internalDialog = true"
      >
      </ui-list-item>
    </v-list>
    <div class="text-right pt-1">
      <v-btn
        color="var(--primary)"
        @click="internalDialog = true"
        variant="text"
        block
        class="btn btn-sm"
      >
        <ui-icon name="plus" />
        {{ btnText }}
      </v-btn>
    </div>
    <v-dialog
      v-model="internalDialog"
      class="dialog-right-drawer"
      transition="slide-x-reverse-transition"
      max-width="900px"
      scrollable
      persistent
    >
      <template #default>
        <v-slide-x-reverse-transition>
          <v-card color="#eff3f7" class="canvas-background">
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="ui-h4 text-white">
                In app filters instellingen</v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-btn
                color="var(--white)"
                class="btn btn-sm"
                @click="internalDialog = false"
              >
                Opslaan
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <div class="container-sm">
                <div class="condition-main py-10">
                  <draggable
                    :list="items"
                    group="filters"
                    :animation="200"
                    :handle="'.drag-btn'"
                  >
                    <div
                      class="condition-cards"
                      v-for="(item, index) in items"
                      :key="index"
                    >
                      <div class="card-group">
                        <div class="ui-card d-flex">
                          <v-btn
                            class="drag-btn ui-btn-icon ui-btn ma-1"
                            size="small"
                            icon
                            varaint="text"
                          >
                            <ui-icon name="grip-vertical" />
                          </v-btn>
                          <collapse-section
                            class="w-100"
                            :title="`Filter ${item.name}`"
                            :open="true"
                          >
                            <k-field-group
                              name=""
                              labelcolclass="py-0"
                              labelsize="12"
                              class="py-0"
                            >
                              <div
                                class="w-100 d-flex justify-content-between flex-wrap flex"
                              >
                                <div
                                  :class="[
                                    item.selected_field ? 'w-33' : 'w-100',
                                    'px-1',
                                  ]"
                                >
                                  <div class="ui-input">
                                    <label class="ui-label">Collectie veld</label>
                                    <v-select
                                      v-model="item.selected_field"
                                      :items="collectionFields"
                                      item-title="label"
                                      item-value="column_name"
                                      variant="solo"
                                      density="compact"
                                      menu-icon="fal fa-chevron-down"
                                      :menu-props="{ class: 'kyano-menu' }"
                                    />
                                  </div>
                                </div>
                                <div class="w-33 pr-1" v-if="item.selected_field">
                                  <div class="ui-input">
                                    <label class="ui-label">Titel</label>
                                    <v-text-field
                                      v-model="item.name"
                                      hide-details
                                      variant="solo"
                                      density="compact"
                                    />
                                  </div>
                                </div>
                                <div class="w-33 pl-1" v-if="item.selected_field">
                                  <div class="ui-input">
                                    <label class="ui-label">Filter type</label>
                                    <v-select
                                      v-model="item.type"
                                      :items="field_types"
                                      item-title="label"
                                      item-value="value"
                                      density="compact"
                                      hide-details
                                      class="bg-filled-input"
                                      variant="solo"
                                      :menu-props="{ class: 'kyano-menu' }"
                                    />
                                  </div>
                                </div>
                              </div>
                            </k-field-group>
                          </collapse-section>
                        </div>
                        <v-btn
                          class="c-delete-btn ui-btn-icon ui-btn"
                          @click="removeRow(index)"
                          color="var(--danger)"
                          size="small"
                          variant="text"
                          icon
                        >
                          <ui-icon name="trash-2" />
                        </v-btn>
                      </div>
                    </div>
                  </draggable>
                  <div class="text-center pb-15">
                    <v-btn
                      color="var(--primary)"
                      class="btn btn-sm text-white"
                      variant="flat"
                      @click="addItem"
                    >
                      <ui-icon name="list-filter-plus" /> Filter toevoegen
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-slide-x-reverse-transition>
      </template>
    </v-dialog>
  </div>
</template>

<script>
  import TipTapInput from "@/components/TipTapInput.vue";
  export default {
    name: "BottomSheetConditions",

    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
      fields: {
        type: Array,
        default: () => [],
      },
      btnText: {
        type: String,
        default: "Toevoegen",
      },
      show: {
        type: Boolean,
        default: false,
      },

      collectionFields: {
        type: Array,
        default: () => [], // Expects array of { label: 'Naam', value: 'veldnaam' }
      },
    },

    components: {
      TipTapInput,
    },

    data() {
      return {
        internalDialog: this.show,
        localConditions: JSON.parse(JSON.stringify(this.modelValue)),
        field_types: [
          { label: "Selecteer menu", value: "select" },
          { label: "Checkbox", value: "checkbox" },
          { label: "Radio", value: "radio" },
        ],
      };
    },

    computed: {
      items: {
        get() {
          return this.modelValue;
        },
        set(newItems) {
          this.$emit("update:modelValue", newItems);
        },
      },
    },
    watch: {
      show(val) {
        this.internalDialog = val;
      },
      internalDialog(val) {
        this.$emit("update:show", val);
      },
      localConditions: {
        deep: true,
        handler(newVal) {
          this.$emit("update:modelValue", newVal);
        },
      },
      modelValue: {
        deep: true,
        handler(newVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(this.localConditions)) {
            this.localConditions = JSON.parse(JSON.stringify(newVal));
          }
        },
      },
    },

    methods: {
      IconForFilterList(item) {
        switch (item) {
          case "select":
            return "chevron-down";
          case "checkbox":
            return "square-check";
          case "radio":
            return "circle-check";
          default:
            return "";
        }
      },
      addItem() {
        this.items.push({
          name: ``,
          value: null,
          type: "",
        });
      },
      removeRow(index) {
        this.items.splice(index, 1);
      },
    },
  };
</script>
<style>
  .condition-cards {
    max-width: 550px;
    position: relative;

    margin: auto;

    .card-group {
      gap: 25px !important;
      display: flex;
    }

    .ui-card {
      width: 100%;
      margin-bottom: 25px;
    }

    .c-delete-btn {
      position: absolute;
      right: -50px;
    }

    .c-and-or {
      position: relative;

      &:before {
        content: "";
        height: 100px;
        width: 3px;
        position: absolute;
        left: 50%;
        top: -50%;
        transform: translateX(-50%);
        background: #515353;
      }
    }

    .v-divider {
      display: none;
    }
  }

  .add-item-btn {
    position: relative;
    overflow: visible;
    z-index: 1;

    &:before {
      content: "";
      height: 50px;
      width: 3px;
      position: absolute;
      left: 50%;
      top: -25px;
      z-index: -1;

      transform: translateX(-50%);
      background: #24a1c7;
    }
  }
</style>
